export const infiniteScrollingModule = {
  name: 'Infinite Scrolling',
};
